import angular from 'angular';
import { forEach, get, pull } from 'lodash';
import sanitizeS3Key from 'common/helpers/sanitize-s3-key';
import uuid from 'node-uuid';

module.exports = angular.module('common.directives.inline-uploads', [
  require('ng-file-upload'),
  require('angular-carousel'),
])
.directive('ocInlineUploads', function() {
  return {
    restrict: 'EA',
    scope: {
      fileBuffer: '=?',
      deleteable: '=',
      deleteWithIcon: '=',
      documentType: '@?',
      documentableId: '=',
      documentableType: '@',
      flipId: '=',
      kind: '@?',
      picableId: '=',
      picableType: '@',
      thumbnailAction: '&?',
      uploadable: '=',
      uploads: '=',
    },
    bindToController: true,
    template: require('./inline-uploads.jade'),
    controller: InlineUploadsCtrl,
    controllerAs: 'inlineUploadsCtrl'
  };
}).name;

class InlineUploadsCtrl {
  // @ngInject
  constructor(Document, Photo, S3, Upload, $uibModal, $scope) {
    this.Document = Document;
    this.Photo = Photo;
    this.S3 = S3;
    this.Upload = Upload;
    this.$uibModal = $uibModal;
    this.$scope = $scope;

    this.type =
      (this.picableId ||
        get(this, 'uploads[0].picable_id') ||
        get(this, 'uploads[0].picableId'))
        ? 'photo'
        : 'document';
    this.uploadMethod = this.type === 'photo' ? 'processPhoto' : 'processDocument';
    if (this.type === 'photo') {
      this.accept = 'image/*';
    } else if (this.documentableType == 'Invoice') {
      this.accept = 'application/pdf';
    } else {
      this.accept = '*';
    }

    this.loadingRadius = 15;

    if (this.type == 'document' && !this.thumbnailAction) {
      if (this.deleteable) {
        this.actionType = 'docDelete';
      } else {
        this.actionType = 'docDownload';
      }
    } else {
      this.actionType = 'default';
    }

    $scope.$watch('inlineUploadsCtrl.files', (files) => {
      forEach(files, (file) => this.process(file));
    });
    $scope.$watchCollection('inlineUploadsCtrl.fileBuffer', (files) => {
      forEach(files, (file) => this.process(file));
    });
  }

  isRealPhoto(upload) {
    return (upload.picable_id || upload.picableId) && !upload.non_photo_file;
  }

  isFileStoredInPhoto(upload) {
    return (upload.picable_id || upload.picableId) && upload.non_photo_file;
  }

  clickUploadAction(upload) {
    if (this.thumbnailAction) {
      this.thumbnailAction({ upload });
    } else if (this.deleteable && !this.deleteWithIcon) {
      this.removeUpload(upload);
    } else {
      this.showPhotoModal();
    }
  }

  showPhotoModal() {
    var newScope = this.$scope.$new({}, this.$scope);
    newScope.photos = this.uploads;

    this.$uibModal.open({
      template: require('./photos-modal.jade')(),
      controller: ModalCtrl,
      scope: newScope,
      size: 'lg',
    });
  }

  removeUpload(upload) {
    let uploadClass = this.type === 'photo' ? this.Photo : this.Document;
    let uploadInstance = new uploadClass(upload);

    uploadInstance.$delete({
      documentable_type: upload.documentable_type,
      documentable_id: upload.documentable_id,
      picable_type: upload.picable_type,
      picable_id: upload.picable_id
    }, () => {
      pull(this.uploads, upload);
    });
  }

  process(file) {
    if (!file) return null;

    let newObj = this[this.uploadMethod](file);
    newObj.name = file.name;
    let key = newObj.key;
    this.uploads.push(newObj);

    this.Upload.upload({
      url: this.S3.rootUrl,
      method: 'POST',
      file: file,
      fields : {
        key: newObj.key,
        AWSAccessKeyId: this.S3.AWSAccessKeyId,
        acl: 'public-read',
        policy: this.S3.publicReadPolicy,
        signature: this.S3.publicReadSignature,
        'Content-Type': file.type || 'application/octet-stream'
      }
    }).progress((progress) => {
      newObj.progress = Math.floor(progress.loaded / progress.total * 100);
    }).success(() => {
      newObj.$save().then(() => {
        let url = this.type === 'photo' ? 'photo_url' : 'url';
        newObj[url] = newObj[url] || this.S3.rootUrl + key;
        delete newObj.key;
      });
    });
  }

  processPhoto(file) {
    let sanitizedFileName = sanitizeS3Key(file.name);
    var key = [
      'uploads',
      'photos',
      this.picableType,
      this.picableId,
      uuid.v4() + '-' + sanitizedFileName,
    ].join('/');
    return new this.Photo({
      picable_type: this.picableType,
      picable_id: this.picableId,
      process: 0,
      key: key,
      kind: this.kind,
    });
  }

  processDocument(file) {
    let sanitizedFileName = sanitizeS3Key(file.name);
    var key = [
      'uploads',
      'documents',
      this.documentableType,
      this.documentableId,
      Date.now() + '-' + sanitizedFileName,
    ].join('/');

    return new this.Document({
      document_type: this.documentType,
      documentable_type: this.documentableType,
      documentable_id: this.documentableId,
      flip_id: this.flipId,
      process: 0,
      key: key,
      kind: this.kind,
    });
  }
}

class ModalCtrl {
  // @ngInject
  constructor($uibModalInstance, $scope) {
    $scope.modalClose = () => $uibModalInstance.dismiss();
  }
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inline-uploads.js
 **/